const KEY = 'board.auth'

export interface AuthState {
  token:     string
  userCode:  number
  nickname:  string
  userType:  number
  expireAt:  string  // ISO 문자열
}

export const auth = {
  /** 로그인 성공 시 저장 */
  set(data: AuthState): void {
    localStorage.setItem(KEY, JSON.stringify(data))
  },

  /** 저장된 인증 정보 읽기 — 만료 시 자동 삭제 후 null 반환 */
  get(): AuthState | null {
    const s = localStorage.getItem(KEY)
    if (!s) return null
    try {
      const d = JSON.parse(s) as AuthState
      if (d.expireAt && new Date(d.expireAt) < new Date()) {
        this.clear()
        return null
      }
      return d
    } catch {
      this.clear()
      return null
    }
  },

  getToken(): string | null {
    return this.get()?.token ?? null
  },

  isAuthenticated(): boolean {
    return this.get() !== null
  },

  clear(): void {
    localStorage.removeItem(KEY)
  },
}

/**
 * 로그인 응답 resultData 파싱
 * 서버 응답: JSON { USER_CODE, NICKNAME, USER_TYPE, TOKEN, EXPIRE_AT }
 * (설계 §8-5 기준 — DataType=1 JSON)
 */
export function parseLoginData(resultData: string): AuthState | null {
  if (!resultData) return null
  try {
    const obj = JSON.parse(resultData) as {
      USER_CODE: number
      NICKNAME:  string
      USER_TYPE: number
      TOKEN:     string
      EXPIRE_AT: string
    }
    if (!obj.TOKEN) return null
    return {
      token:    obj.TOKEN,
      userCode: obj.USER_CODE,
      nickname: obj.NICKNAME,
      userType: obj.USER_TYPE,
      expireAt: obj.EXPIRE_AT,
    }
  } catch {
    return null
  }
}
